import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = {
  key: 0,
  class: "collapse-icon"
}
const _hoisted_3 = { class: "bottom-bar" }
const _hoisted_4 = { class: "control-block" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Logo = _resolveComponent("Logo")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_NavbarList = _resolveComponent("NavbarList")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_NavbarItem = _resolveComponent("NavbarItem")
  const _component_Feedback = _resolveComponent("Feedback")
  const _component_router_link = _resolveComponent("router-link")
  const _component_NavbarProfile = _resolveComponent("NavbarProfile")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: "nav-logo pointer",
      onClick: _cache[1] || (_cache[1] = (...args) => ($options.onLogo && $options.onLogo(...args)))
    }, [
      _createVNode(_component_Logo, {
        class: "pointer logo-pic",
        size: "3.2rem",
        type: "logo"
      }),
      ($props.showPin || _ctx.$slots.collapse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "collapse", {}, () => [
              _createVNode(_component_Tooltip, {
                text: `${$props.pinned ? 'Unpin' : 'Pin'} sidebar`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    hoverable: "",
                    icon: $props.pinned ? 'pin-01' : 'pin-02',
                    stroke: "var(--gray-500)",
                    size: "2rem",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('update:pinned', !$props.pinned)), ["stop"]))
                  }, null, 8 /* PROPS */, ["icon"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"])
            ], true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "new-genrate",
      onClick: _cache[2] || (_cache[2] = (...args) => ($options.onNewChat && $options.onNewChat(...args)))
    }, [
      _createVNode(_component_Icon, {
        size: "1.8rem",
        icon: "edit-05",
        stroke: "var(--gray-500)",
        "stroke-width": "1.2"
      }),
      _cache[4] || (_cache[4] = _createElementVNode("div", null, "New Chat", -1 /* HOISTED */))
    ]),
    _createVNode(_component_ScrollBar, {
      ref: "scroller",
      class: "scroller",
      fade: "",
      "bar-x-offset": "-0.4rem"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_NavbarList, {
          items: $props.items,
          class: "navbar-list",
          onShow: _cache[3] || (_cache[3] = $event => (_ctx.$emit('show', $event)))
        }, null, 8 /* PROPS */, ["items"]), [
          [_directive_resize, $options.refresh, "300"]
        ])
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Divider, {
        m: "0.6rem 2.5rem",
        bg: "var(--border-primary)"
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Feedback, {
          "show-popover": "",
          divider: "",
          teleported: "",
          "popper-class": "navbar-feedback",
          placement: "top-start",
          "min-length": 10,
          width: "28rem",
          rows: 6,
          "fb-id": $data.fb_id,
          onShow: $options.onFeedbackShow,
          onSend: $options.onSend
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NavbarItem, {
              icon: "message-text-square-02",
              title: "Feedback",
              active: $data.fb_opened
            }, null, 8 /* PROPS */, ["active"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["fb-id", "onShow", "onSend"]),
        (_ctx.$responsive.desktop)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "link",
              to: {name: 'settings', query: {tab: _ctx.$route.query.tab}}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_NavbarItem, {
                  icon: "settings-01",
                  title: "Settings",
                  active: $options.is_settings
                }, null, 8 /* PROPS */, ["active"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_Divider, {
        m: "0.8rem 2.1rem 0",
        bg: "var(--border-primary)"
      }),
      _createVNode(_component_NavbarProfile, { class: "profile" })
    ])
  ]))
}